import { render } from "./CampaignFilterItem.vue?vue&type=template&id=d54e6a2a"
import script from "./CampaignFilterItem.vue?vue&type=script&lang=js"
export * from "./CampaignFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__